import { PlusOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col as ColAnt,
  Form,
  Grid,
  Input,
  message,
  Row,
  Select
} from 'antd';
import * as moment from 'moment';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import CustomDatePicker from '../../components/CustomDatePicker';
import NumericInput from '../../components/NumericInput';
import EmpresaContext from '../../context/empresa-context';
import { useSolicitudContext } from '../../context/solicitud-context';
import { relacionesAsegurados, validarCaracterEspecial } from '../../utils';

const { Option } = Select;
const { useBreakpoint } = Grid;

const headerStyle = {
  color: 'rgba(0, 0, 0, 0.85)',
  fontWeight: 500,
  textAlign: 'left',
  background: '#fafafa',
  borderTop: '1px solid #f0f0f0',
  borderBottom: '1px solid #f0f0f0',
  borderRight: '1px solid #f0f0f0'
};

const AseguradosList = ({ defaultList, onBack, onNext, plan, cotizacion }) => {
  const [form] = Form.useForm();
  const screens = useBreakpoint();
  let incluyeOtros = false;
  const { getProductoActual } = useContext(EmpresaContext);
  const { changeData } = useSolicitudContext();
  const { incluye_conyuge, incluye_hijos } = getProductoActual();
  const newDefaultList = {};
  const montosPorTipo = plan
    ? {
        titular: Number(plan.monto_total),
        conyuge: Number(plan.monto_total_conyuge),
        hijo: Number(plan.monto_total_hijos)
      }
    : {};
  const [personaBCP, setPersonaBCP] = useState(false);
  if (
    (incluye_conyuge || incluye_hijos) &&
    (montosPorTipo.hijo || montosPorTipo.conyuge)
  ) {
    incluyeOtros = true;
  }
  if (defaultList?.list?.length > 0) {
    newDefaultList.list = [...defaultList.list];
  } else {
    newDefaultList.list = [{ tipo: 'titular' }];
  }
  newDefaultList.list[0].monto = montosPorTipo.titular;

  useEffect(() => {
    if (defaultList?.list?.length > 0) {
      if (defaultList.list[0].personaBCP) {
        setPersonaBCP(true);
      }
    }
  }, [defaultList]);

  const onFinish = (values) => {
    if (!values.list || values.list.length === 0) {
      message.warning('Definí un asegurado');
      return;
    }

    const sinFecha = values.list.some((item) => !item.fechaNacimiento);
    if (sinFecha) {
      message.warning('Debe cargar las fechas de nacimiento');
      return;
    }
    const { aseguradoraEmpresaProducto } = cotizacion;
    const edadPermitida = aseguradoraEmpresaProducto.edadMaxima || 65;
    const mayor = values.list.some((item) => {
      const edad = moment().diff(item.fechaNacimiento, 'years');
      return edad > edadPermitida;
    });
    if (mayor) {
      message.warning(`El límite de edad permitido es ${edadPermitida}`);
      return;
    }

    if (onNext) {
      onNext(values);
    }
  };

  const onFinishFailed = () => {
    message.warning('Completá todos los campos requeridos.');
  };

  const goBack = () => {
    const { getFieldsValue } = form;
    if (onBack) {
      onBack(getFieldsValue());
    }
  };

  const Col = !screens.md
    ? ColAnt
    : styled((props) => (
        <ColAnt
          {...props}
          style={{
            ...props.style,
            paddingTop: 16,
            paddingBottom: 16,
            paddingLeft: 16,
            paddingRight: 16
          }}
        />
      ))`
        border-right: 1px solid #f0f0f0;
        border-bottom: 1px solid #f0f0f0;
        transition: background 0.3s;
        padding-top: 16px;
        padding-bottom: 16px;
        padding-left: 16px;
        padding-right: 16px;
        &:first-child {
          border-left: 1px solid #f0f0f0;
        }
        &:hover {
          background: #fafafa;
        }
      `;

  const handleInputChange = (field, { target }) => {
    changeData(field, target.value);
  };

  function onChangeDatePicket(date, dateString) {
    changeData('fecha nacimiento', dateString);
  }

  const AseguradoForm = ({ field }) => {
    const { getFieldValue: getFieldValueForm, setFieldsValue } = form;
    return (
      <>
        <Col
          xs={24}
          md={8}
          align="start"
          style={screens.md ? { borderLeft: '1px solid #f0f0f0' } : null}
        >
          <Form.Item
            {...field}
            name={[field.name, 'nombres']}
            label={screens.md ? '' : 'Nombres y Apellidos'}
            fieldKey={[field.fieldKey, 'nombres']}
            rules={[{ required: true, message: 'Campo requerido' }]}
            onKeyPress={(e) => {
              const pressedKey = String.fromCharCode(
                !e.charCode ? e.which : e.charCode
              );
              validarCaracterEspecial(e, pressedKey);
            }}
            onPaste={(e) => {
              const pastedText = e.clipboardData.getData('text');
              validarCaracterEspecial(e, pastedText);
            }}
            onChange={(e) => {
              handleInputChange('nombres', e);
            }}
          >
            <Input placeholder="Nombres y Apellidos" disabled={!!personaBCP} />
          </Form.Item>
        </Col>
        <Col xs={24} md={4} align="start">
          <Form.Item
            {...field}
            name={[field.name, 'cedula']}
            label={screens.md ? '' : 'Cédula'}
            fieldKey={[field.fieldKey, 'cedula']}
            rules={[
              { required: field.fieldKey === 0, message: 'Campo requerido' }
            ]}
            onChange={(e) => {
              handleInputChange('cedula', e);
            }}
          >
            <NumericInput placeholder="Nro de Cédula" disabled={!!personaBCP} />
          </Form.Item>
        </Col>
        <Col xs={24} md={4} align="start">
          <Form.Item noStyle shouldUpdate>
            <>
              <Form.Item
                {...field}
                label={screens.md ? '' : 'Relación'}
                name={[field.name, 'tipo']}
                fieldKey={[field.fieldKey, 'tipo']}
                rules={[{ required: true, message: 'Campo requerido' }]}
              >
                <Select
                  placeholder="Elegir"
                  open={field.fieldKey === 0 ? false : undefined}
                  onChange={(tipo) => {
                    let list = getFieldValueForm('list');
                    list = list.map((item, index) => {
                      return index === field.name
                        ? { ...item, monto: montosPorTipo[tipo] }
                        : item;
                    });
                    setFieldsValue({ list });
                  }}
                >
                  {relacionesAsegurados
                    .filter((item) => {
                      if (item.value === 'conyuge' && !montosPorTipo.conyuge) {
                        return false;
                      }
                      if (item.value === 'hijo' && !montosPorTipo.hijo) {
                        return false;
                      }
                      return true;
                    })
                    .map((item) => (
                      <Option
                        key={item.value}
                        value={item.value}
                        disabled={item.value === 'titular'}
                      >
                        {item.label}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </>
          </Form.Item>
        </Col>
        <Col xs={24} md={5} align="start">
          <Form.Item
            {...field}
            label={screens.md ? '' : 'Fecha Nacimiento'}
            name={[field.name, 'fechaNacimiento']}
            fieldKey={[field.fieldKey, 'fechaNacimiento']}
            rules={[{ required: true, message: 'Campo requerido' }]}
          >
            <CustomDatePicker
              style={{ width: '100%' }}
              placeholder="DD/MM/YYYY"
              format="DD/MM/YYYY"
              onChange={onChangeDatePicket}
              disabled={!!personaBCP}
            />
          </Form.Item>
        </Col>
      </>
    );
  };

  return (
    <>
      <Form
        name="aseguradosList"
        initialValues={newDefaultList}
        scrollToFirstError
        onFinish={onFinish}
        onFinishFailed={() => onFinishFailed()}
        form={form}
        layout="vertical"
        autoComplete="off"
      >
        <Form.List name="list">
          {(fields, { add, remove }) => {
            return (
              <>
                {screens.md && (
                  <Row
                    gutter={[16, 0]}
                    style={{
                      maxWidth: '1200px',
                      marginTop: 'auto',
                      marginBottom: 'auto',
                      marginLeft: 'auto',
                      marginRight: 'auto'
                    }}
                  >
                    <Col xs={24} md={8} align="start" style={headerStyle}>
                      Nombres y Apellidos
                    </Col>
                    <Col xs={24} md={4} align="start" style={headerStyle}>
                      Cédula
                    </Col>
                    <Col xs={26} md={4} align="start" style={headerStyle}>
                      Relación de parentezco
                    </Col>
                    <Col
                      xs={16}
                      md={5}
                      align="start"
                      style={{ ...headerStyle, textAlign: 'right' }}
                    >
                      Fecha Nacimiento
                    </Col>
                    <Col xs={24} md={3} align="flex-end" style={headerStyle} />
                    {fields.map((field, index) => (
                      <Fragment key={field.key}>
                        <AseguradoForm field={field} />
                        <Col xs={24} md={3} align="start">
                          {index > 0 && (
                            <Button
                              type="dashed"
                              danger
                              onClick={() => {
                                remove(field.name);
                              }}
                            >
                              Borrar
                            </Button>
                          )}
                        </Col>
                      </Fragment>
                    ))}
                    {incluyeOtros && (
                      <ColAnt xs={24} style={{ paddingTop: 20 }}>
                        <Form.Item>
                          <Button
                            type="primary"
                            shape="round"
                            onClick={() => {
                              add();
                            }}
                          >
                            <PlusOutlined /> Agregar asegurado adicional
                          </Button>
                        </Form.Item>
                      </ColAnt>
                    )}
                  </Row>
                )}
                {screens.md === false && (
                  <>
                    {fields.map((field, index) => (
                      <Card
                        key={field.key}
                        bodyStyle={{ paddingBottom: 8 }}
                        style={{ marginBottom: 16 }}
                        actions={
                          index > 0
                            ? [
                                <Button
                                  type="dashed"
                                  danger
                                  onClick={() => {
                                    remove(field.name);
                                  }}
                                >
                                  Borrar
                                </Button>
                              ]
                            : []
                        }
                      >
                        <Row
                          gutter={[8, 4]}
                          style={{ maxWidth: '1600px', margin: 'auto' }}
                        >
                          <AseguradoForm field={field} />
                        </Row>
                      </Card>
                    ))}
                    <Col xs={24} style={{ paddingTop: 20 }}>
                      {incluyeOtros && (
                        <Form.Item>
                          <Button
                            type="primary"
                            shape="round"
                            onClick={() => {
                              add();
                            }}
                          >
                            <PlusOutlined /> Agregar asegurado adicional
                          </Button>
                        </Form.Item>
                      )}
                    </Col>
                  </>
                )}
              </>
            );
          }}
        </Form.List>

        <Form.Item>
          <Button style={{ margin: 10 }} onClick={goBack}>
            Anterior
          </Button>
          <Button style={{ margin: 10 }} type="primary" htmlType="submit">
            Siguiente
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default AseguradosList;
